import { IAppState } from '../../redux';

export const selectUserId = (state: IAppState): number | undefined => {
  return state.user.userId;
};
